import { Button, Card, CardActions, CardMedia, Grid, Typography, Fab } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect } from "react";
import ApiManager from "../ApiClient/ApiManager";
import BillView from "../Components/BillView/BillView";
import CollageJourneyMapSection from "../Components/CartSections/CollageJourneyMapSection/CollageJourneyMapSection";
import DigitalDownloadsSection from "../Components/CartSections/DigitalDownloadsSection/DigitalDownloadsSection";
import PrintsSection from "../Components/CartSections/PrintsSection/PrintsSection";
import FooterNote from "../Components/FoooterNote/FooterNote";
import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Header";
import HeaderNote from "../Components/HeaderNote/HeaderNote";
import SummarySection from "../Components/SummarySection/SummarySection";
import SectionTitle2 from "../Components/Ui-Components/SectionTitle2/SectionTitle2";
import ColorHelper from "../Helpers/ColorHelper";
import { useSelector } from "react-redux";
import ConstantHelper from "../Helpers/ConstantHelper";
import axios from "axios";
import { useState } from "react";
import {
  addToCart,
  getCartDetails,
  orderInfo,
  removeFromCart,
} from "../redux/shoppingActions";
import { useDispatch } from "react-redux";
import EmptyCart from "../Components/CartSections/EmptyCart/EmptyCart";
import { useLocation } from "react-router-dom";
import { Pause, PlayCircle, KeyboardArrowUp, KeyboardArrowDown } from "@mui/icons-material";
import FontHelper from "../Helpers/FontHelper";
import SectionTitle3 from "../Components/Ui-Components/SectionTitle3/SectionTitle3";
import { isEmpty } from "lodash";
import AddToCartAddedBtn from "../Components/PorductCard/ProductCardComps/AddToCartAddedBtn";
import { useNavigate } from "react-router-dom";
const OrderDetails = () => {
  const { state, search } = useLocation();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const orderref = new URLSearchParams(search).get("orderref");
  const e = new URLSearchParams(search).get("e");
  const lt = new URLSearchParams(search).get("lt");
  const h = new URLSearchParams(search).get("h");

  const navigate = useNavigate();

  const stateDetails = useSelector((state) => state.shop.products);
  const cartDetails = useSelector((state) => state.shop?.cartInfo);
  const cartInfo = useSelector((state) => state.shop.cartInfo);
  const [downloadsCart, setDownloadsCart] = useState();
  const [showBackToTop, setShowBackToTop] = useState(false);
  let isPending = localStorage?.getItem("isPending");

  const [play, setPlay] = useState(false);
  const vidRef = React.useRef(null);
  const dispatch = useDispatch();

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [isNearBottom, setIsNearBottom] = useState(false);
  const itemsPerPage = 100; // 4x2 grid layout
  const paginationRef = React.useRef(null);

  const handlePlayVideo = () => {
    vidRef.current?.play();
  };
  const handlePuaseVideo = () => {
    vidRef.current?.pause();
  };

  const updateBill = (updatedCart) => { };

  const [AddToCartText, setAddtoCartText] = useState("Add To Cart");

  // const CardBtnStyle = {
  //   fontFamily: FontHelper.fBold,
  //   fontSize: 12,
  //   color: ColorHelper.WhiteColor,
  //   backgroundColor: " #3f0e77",
  //   px: { xs: "0px", md: "15px" },
  //   py: { xs: "0px", md: "10px" },
  //   height: { xs: "40px", md: "auto" },
  //   borderRadius: 0,
  //   textTransform: "capitalize",
  //   width: "100%",
  //   minWidth: "auto",
  //   mb: 0,
  //   display: "flex",
  //   justifycontent: "center",
  //   alignItems: "center",
  //   flexWrap: "wrap",
  //   "&:hover": {
  //     backgroundColor: "#22c55e",
  //     borderRadius: "3px",
  //   },
  //   "> span": {
  //     mx: { xs: 0, lg: 0.3 },
  //   },
  // };

  // const handleAddtoCart = (id, image, product, type, price) => {
  //   const cartItems = {
  //     id: id,
  //     image: image,
  //     category: "video", //video
  //     bibNumber: stateDetails.bibNumber,
  //     type: "download", //download
  //     videopath: image,
  //   };
  //   product == undefined &&
  //     price == undefined &&
  //     dispatch(addToCart(cartDetails, cartItems));
  //   setAddtoCartText("Added");

  //   if (AddToCartText == "Added") {
  //     dispatch(removeFromCart(id, cartDetails));
  //     setAddtoCartText("Add To Cart");
  //   }
  // };

  useEffect(() => {
    fetchOrderDetails();
  }, []);

  // Handle scroll for back to top button
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercentage = (scrollTop / docHeight) * 100;

      setShowBackToTop(scrollTop > 300);
      setIsNearBottom(scrollPercentage > 70);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const fetchOrderDetails = async () => {
    setIsLoading(true);

    const response = await axios.get(
      ApiManager.preAuthDownload() +
      `?orderref=${orderref}&e=${e}&lt=${lt}&h=${h}`
    );
    if (response.data.StatusCode === 200) {
      setIsLoading(false);

      dispatch(
        orderInfo(
          response.data.result.bib_no,
          response.data.result.order_ref,
          response.data.result.eventID
        )
      );
      setDownloadsCart(response.data.result);
      setCurrentPage(1); // Reset to first page when data loads
    } else {
      setIsLoading(false);
    }
  };

  // Pagination logic
  const getPaginatedData = () => {
    if (!downloadsCart?.photo) return [];
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return downloadsCart.photo.slice(startIndex, endIndex);
  };

  const getTotalPages = () => {
    if (!downloadsCart?.photo) return 0;
    return Math.ceil(downloadsCart.photo.length / itemsPerPage);
  };

  const getRangeLabel = () => {
    const totalPhotos = downloadsCart?.photo?.length || 0;
    const startRange = (currentPage - 1) * itemsPerPage;
    const endRange = Math.min(currentPage * itemsPerPage - 1, totalPhotos - 1);
    return `${startRange} - ${endRange}`;
  };

  const handleNextPage = () => {
    if (currentPage < getTotalPages()) {
      setCurrentPage(currentPage + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Get visible page buttons (show 5 pages at a time)
  const getVisiblePages = () => {
    const totalPages = getTotalPages();
    const maxPagesToShow = 5;

    // If total pages is 7 or less, show all pages
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    let startPage, endPage;

    // Calculate the range based on current page position
    if (currentPage <= 3) {
      startPage = 1;
      endPage = 5;
    } else if (currentPage >= totalPages - 2) {
      startPage = totalPages - 4;
      endPage = totalPages;
    } else {
      startPage = currentPage - 2;
      endPage = currentPage + 2;
    }

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  };

  const renderPaginationButtons = () => {
    const totalPages = getTotalPages();
    const visiblePages = getVisiblePages();

    // If 7 or fewer pages, show all without ellipsis
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNumber) => (
        <Button
          key={pageNumber}
          onClick={() => handlePageClick(pageNumber)}
          sx={{
            fontFamily: FontHelper.fBold,
            fontSize: { xs: 10, md: 12 },
            minWidth: { xs: 35, md: 45 },
            height: { xs: 35, md: 40 },
            backgroundColor: currentPage === pageNumber ? "#3f0e77" : "#FFFFFF",
            color: currentPage === pageNumber ? ColorHelper.WhiteColor : ColorHelper.BlackColor,
            border: currentPage === pageNumber ? `2px solid #3f0e77` : "2px solid #E0E0E0",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: currentPage === pageNumber ? "bold" : "normal",
            padding: { xs: "4px", md: "8px" },
            flexShrink: 0,
            "&:hover": {
              backgroundColor: currentPage === pageNumber ? "#3f0e77" : "#F0F0F0",
              borderColor: currentPage === pageNumber ? "#3f0e77" : "#D0D0D0",
            },
          }}
        >
          {pageNumber}
        </Button>
      ));
    }

    const buttons = [];
    const firstPage = visiblePages[0];
    const lastPage = visiblePages[visiblePages.length - 1];

    // Show first page if not in visible range
    if (firstPage > 1) {
      buttons.push(
        <Button
          key={1}
          onClick={() => handlePageClick(1)}
          sx={{
            fontFamily: FontHelper.fBold,
            fontSize: { xs: 10, md: 12 },
            minWidth: { xs: 28, md: 45 },
            height: { xs: 28, md: 40 },
            backgroundColor: "#FFFFFF",
            color: ColorHelper.BlackColor,
            border: "2px solid #E0E0E0",
            borderRadius: "6px",
            cursor: "pointer",
            padding: { xs: "2px", md: "8px" },
            flexShrink: 0,
            "&:hover": { backgroundColor: "#F0F0F0" },
          }}
        >
          1
        </Button>
      );
      if (firstPage > 2) {
        buttons.push(
          <Typography key="start-ellipsis" sx={{ fontFamily: FontHelper.fBold, fontSize: { xs: 12, md: 14 }, flexShrink: 0 }}>
            ...
          </Typography>
        );
      }
    }

    // Show visible pages
    visiblePages.forEach((pageNumber) => {
      buttons.push(
        <Button
          key={pageNumber}
          onClick={() => handlePageClick(pageNumber)}
          sx={{
            fontFamily: FontHelper.fBold,
            fontSize: { xs: 10, md: 12 },
            minWidth: { xs: 35, md: 45 },
            height: { xs: 35, md: 40 },
            backgroundColor: currentPage === pageNumber ? "#3f0e77" : "#FFFFFF",
            color: currentPage === pageNumber ? ColorHelper.WhiteColor : ColorHelper.BlackColor,
            border: currentPage === pageNumber ? `2px solid #3f0e77` : "2px solid #E0E0E0",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: currentPage === pageNumber ? "bold" : "normal",
            padding: { xs: "4px", md: "8px" },
            flexShrink: 0,
            "&:hover": {
              backgroundColor: currentPage === pageNumber ? "#3f0e77" : "#F0F0F0",
              borderColor: currentPage === pageNumber ? "#3f0e77" : "#D0D0D0",
            },
          }}
        >
          {pageNumber}
        </Button>
      );
    });

    // Show last page if not in visible range
    if (lastPage < totalPages) {
      if (lastPage < totalPages - 1) {
        buttons.push(
          <Typography key="end-ellipsis" sx={{ fontFamily: FontHelper.fBold, fontSize: { xs: 12, md: 14 }, flexShrink: 0 }}>
            ...
          </Typography>
        );
      }
      buttons.push(
        <Button
          key={totalPages}
          onClick={() => handlePageClick(totalPages)}
          sx={{
            fontFamily: FontHelper.fBold,
            fontSize: { xs: 10, md: 12 },
            minWidth: { xs: 35, md: 45 },
            height: { xs: 35, md: 40 },
            backgroundColor: "#FFFFFF",
            color: ColorHelper.BlackColor,
            border: "2px solid #E0E0E0",
            borderRadius: "6px",
            cursor: "pointer",
            padding: { xs: "4px", md: "8px" },
            flexShrink: 0,
            "&:hover": { backgroundColor: "#F0F0F0" },
          }}
        >
          {totalPages}
        </Button>
      );
    }

    return buttons;
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToPagination = () => {
    if (paginationRef.current) {
      paginationRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const downloadFile = (url) => {
    try {
      console.log('Download URL:', url);
      console.log('Attempting to download file...');

      // Create an anchor element with download attribute
      const link = document.createElement('a');
      link.href = url;
      link.download = ''; // Empty string means use the filename from the URL
      link.target = '_blank';
      link.rel = 'noopener noreferrer';

      // Trigger the download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      console.log('Download initiated successfully');
    } catch (error) {
      console.error('Download error:', error);
    }
  };

  return (
    <Box>
      <div style={{ display: isLoading ? "flex" : "none" }} className="modal">
        <div className="modal-content">
          <div className="loader"></div>
          <div className="modal-text">Processing...</div>
        </div>
      </div>
      <>
        <Box>
          <Header bib={121} />
          <>
            <SectionTitle2
              title={downloadsCart?.eventName}
              eventLogo={downloadsCart?.eventLogo}
              eventLogoShow={true}
              bgColor={ColorHelper.WhiteColo4}
            />
            <HeaderNote priceInfo={"Order Details"} />

            {downloadsCart && (
              <SummarySection
                orderId={downloadsCart?.order_ref}
                urls={downloadsCart?.photo}
                count={downloadsCart?.photo.length}
                bibNumber={downloadsCart?.bib_no}
                price={downloadsCart?.orderTotal_amount}
                logo={downloadsCart?.eventLogo}
                type="orderDetails"
              />
            )}
            <Grid
              container
              sx={{
                backgroundColor: ColorHelper.WhiteColor2,
                pb: 12,
                px: { xs: 4, md: 5, lg: 10 },
              }}
            >
              <Grid item xs={12} md={12}>
                {downloadsCart?.photo?.length > 0 ? (
                  <DigitalDownloadsSection
                    data={getPaginatedData()}
                    updateBill={updateBill}
                    type={"orderDetails"}
                    bibNumber={downloadsCart?.bib_no}
                    orderId={downloadsCart?.order_ref}
                  />
                ) : null}
                {downloadsCart?.prints.filter((item) => {
                  return item.type === "print";
                }).length > 0 ? (
                  <PrintsSection
                    data={downloadsCart?.prints.filter((item) => {
                      return item.type === "print";
                    })}
                    print_instructions={downloadsCart?.print_instructions}
                    updateBill={updateBill}
                    type={"orderDetails"}
                  />
                ) : null}
                {downloadsCart?.prints.filter((item) => {
                  return item.type.includes("collage");
                }).length > 0 && (
                    <CollageJourneyMapSection
                      collageCart={downloadsCart?.prints.filter((item) => {
                        return item.type.includes("collage");
                      })}
                      collage="collage"
                    />
                  )}
                {!isEmpty(downloadsCart?.video) && (
                  <SectionTitle3 title={ConstantHelper.Videos} />
                )}
                {downloadsCart?.video?.length > 0 &&
                  downloadsCart?.video?.map((item) => (
                    <Card
                      sx={{
                        width: "22%",
                        "@media screen and (min-width: 320px) and (max-width: 430px)":
                        {
                          width: "100%",
                        },
                        "@media screen and (width: 820px)": {
                          width: "47%",
                        },
                        "@media screen and (width: 768px)": {
                          width: "47%",
                        },
                        p: "20px",
                        pb: "5px",
                        // height: "25%",
                        //   m: 2,
                        borderRadius: "5px 5px 0 0",
                        border: `1px solid ${ColorHelper.LightGrey4}`,
                        position: "relative",
                        overflow: "visible",
                        alignSelf: "flex-start",
                      }}
                      key={item.imageid}
                    >
                      <CardMedia
                        component={"video"}
                        alt="Please refresh the page or remove this image"
                        height="auto"
                        ref={vidRef}
                        sx={{
                          borderRadius: "3px",
                          maxWidth: "100%",
                          aspectRatio: "1/1",
                          maxHeight: "100%",
                          objectFit: "cover",
                        }}
                        src={item?.s3}
                      />

                      <CardActions sx={{ px: 0 }}>
                        {/* {isPending === "true" ? (
                        <AddToCartAddedBtn
                          AddToCartText={AddToCartText}
                          CardBtnStyle={CardBtnStyle}
                          handleCartBtn={() => {
                            handleAddtoCart(
                              item.imageid,
                              item.s3,
                              undefined,
                              "download",
                              undefined
                            );
                          }}
                        />
                      ) : ( */}
                        <Button
                          onClick={() => {
                            downloadFile(item?.s3);
                          }}
                          disableripple={true}
                          sx={{
                            backgroundColor: "#12B76A",
                            fontFamily: FontHelper.fBold,
                            fontSize: 12,
                            color: ColorHelper.WhiteColor,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            px: "15px",
                            py: "10px",
                            borderRadius: 0,
                            // marginLeft: "auto",
                            mb: 0,
                            "&:hover": { backgroundColor: "#12B76A" },
                          }}
                        >
                          <span
                            style={{
                              fontFamily: FontHelper.fBold,
                              fontSize: 13,
                            }}
                          >
                            {" "}
                            {"Download"}{" "}
                          </span>
                        </Button>
                        {/* )} */}
                      </CardActions>
                    </Card>
                  ))}
              </Grid>
            </Grid>

            {/* Pagination Controls */}
            {downloadsCart?.photo?.length > itemsPerPage && (
              <Box
                ref={paginationRef}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: { xs: 0.2, md: 2 },
                  mt: 4,
                  mb: 4,
                  px: 0,
                  width: "100%",
                  flexWrap: "nowrap",
                  backgroundColor: "#F5F5F5",
                  padding: { xs: "8px 4px", md: "20px 40px" },
                  borderTop: "1px solid #E0E0E0",
                  borderBottom: "1px solid #E0E0E0",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                  overflowX: { xs: "auto", md: "visible" },
                  overflowY: "hidden",
                }}
              >
                <Button
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                  sx={{
                    fontFamily: FontHelper.fBold,
                    fontSize: { xs: 9, md: 13 },
                    minWidth: "auto",
                    height: { xs: 28, md: 40 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: currentPage === 1 ? "#D4D4D4" : "#3f0e77",
                    color: currentPage === 1 ? "#999999" : ColorHelper.WhiteColor,
                    px: { xs: 2, md: 2.5 },
                    py: { xs: 0.5, md: 1.2 },
                    borderRadius: "6px",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    textTransform: "none",
                    border: "none",
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                    "&:hover": {
                      backgroundColor: currentPage === 1 ? "#D4D4D4" : "#3f0e77",
                    },
                  }}
                >
                  <Box sx={{ display: { xs: "none", md: "block" } }}>← Previous</Box>
                  <Box sx={{ display: { xs: "block", md: "none" } }}>←</Box>
                </Button>

                <Box sx={{
                  display: "flex",
                  gap: { xs: 0.2, md: 0.8 },
                  mx: { xs: 0.6, md: 0 },
                  flexWrap: "nowrap",
                }}>
                  {currentPage > 1 && (
                    <>
                      <Button
                        onClick={() => handlePageClick(1)}
                        sx={{
                          fontFamily: FontHelper.fBold,
                          fontSize: { xs: 10, md: 12 },
                          minWidth: { xs: 28, md: 45 },
                          height: { xs: 28, md: 40 },
                          backgroundColor: "#FFFFFF",
                          color: ColorHelper.BlackColor,
                          border: `2px solid #E0E0E0`,
                          borderRadius: "6px",
                          cursor: "pointer",
                          padding: { xs: "2px", md: "8px" },
                          "&:hover": {
                            backgroundColor: "#F0F0F0",
                          },
                        }}
                      >
                        1
                      </Button>
                      {currentPage > 3 && (
                        <Typography sx={{ fontFamily: FontHelper.fBold, fontSize: { xs: 12, md: 14 } }}>
                          ...
                        </Typography>
                      )}
                    </>
                  )}

                  {getVisiblePages()
                    .filter((pageNumber) => !(currentPage > 1 && pageNumber === 1))
                    .map((pageNumber) => (
                      <Button
                        key={pageNumber}
                        onClick={() => handlePageClick(pageNumber)}
                        sx={{
                          fontFamily: FontHelper.fBold,
                          fontSize: { xs: 10, md: 12 },
                          minWidth: { xs: 28, md: 45 },
                          height: { xs: 28, md: 40 },
                          backgroundColor:
                            currentPage === pageNumber ? "#3f0e77" : "#FFFFFF",
                          color:
                            currentPage === pageNumber
                              ? ColorHelper.WhiteColor
                              : ColorHelper.BlackColor,
                          border:
                            currentPage === pageNumber
                              ? `2px solid #3f0e77`
                              : "2px solid #E0E0E0",
                          borderRadius: "6px",
                          cursor: "pointer",
                          fontWeight: currentPage === pageNumber ? "bold" : "normal",
                          padding: { xs: "2px", md: "8px" },
                          "&:hover": {
                            backgroundColor:
                              currentPage === pageNumber ? "#3f0e77" : "#F0F0F0",
                            borderColor:
                              currentPage === pageNumber ? "#3f0e77" : "#D0D0D0",
                          },
                        }}
                      >
                        {pageNumber}
                      </Button>
                    ))}

                  {currentPage < getTotalPages() - 1 && (
                    <>
                      {currentPage < getTotalPages() - 2 && (
                        <Typography sx={{ fontFamily: FontHelper.fBold, fontSize: { xs: 12, md: 14 } }}>
                          ...
                        </Typography>
                      )}
                      <Button
                        onClick={() => handlePageClick(getTotalPages())}
                        sx={{
                          fontFamily: FontHelper.fBold,
                          fontSize: { xs: 10, md: 12 },
                          minWidth: { xs: 28, md: 45 },
                          height: { xs: 28, md: 40 },
                          backgroundColor: "#FFFFFF",
                          color: ColorHelper.BlackColor,
                          border: "2px solid #E0E0E0",
                          borderRadius: "6px",
                          cursor: "pointer",
                          padding: { xs: "2px", md: "8px" },
                          "&:hover": {
                            backgroundColor: "#F0F0F0",
                          },
                        }}
                      >
                        {getTotalPages()}
                      </Button>
                    </>
                  )}
                </Box>

                <Button
                  onClick={handleNextPage}
                  disabled={currentPage === getTotalPages()}
                  sx={{
                    fontFamily: FontHelper.fBold,
                    fontSize: { xs: 9, md: 13 },
                    minWidth: "auto",
                    px: { xs: 2, md: 2.5 },
                    py: { xs: 0.5, md: 1.2 },
                    height: { xs: 28, md: 40 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor:
                      currentPage === getTotalPages() ? "#D4D4D4" : "#3f0e77",
                    color:
                      currentPage === getTotalPages() ? "#999999" : ColorHelper.WhiteColor,
                    borderRadius: "6px",
                    cursor:
                      currentPage === getTotalPages()
                        ? "not-allowed"
                        : "pointer",
                    textTransform: "none",
                    border: "none",
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                    "&:hover": {
                      backgroundColor:
                        currentPage === getTotalPages()
                          ? "#D4D4D4"
                          : "#3f0e77",
                    },
                  }}
                >
                  <Box sx={{ display: { xs: "none", md: "block" } }}>Next →</Box>
                  <Box sx={{ display: { xs: "block", md: "none" } }}>→</Box>
                </Button>
              </Box>
            )}

            {/* Animated Back to Top / Go to Pagination Button */}
            {showBackToTop && (
              <Fab
                onClick={isNearBottom ? scrollToTop : scrollToPagination}
                sx={{
                  position: "fixed",
                  bottom: { xs: 20, md: 20 },
                  right: { xs: 8, md: 12 },
                  backgroundColor: "#3f0e77",
                  color: ColorHelper.WhiteColor,
                  zIndex: 1000,
                  transition: "all 0.3s ease",
                  "@keyframes spinUp": {
                    "0%": { transform: "translateY(10px) rotate(0deg)", opacity: 0 },
                    "100%": { transform: "translateY(0px) rotate(0deg)", opacity: 1 },
                  },
                  "@keyframes slideDown": {
                    "0%": { transform: "translateY(-10px) rotate(0deg)", opacity: 0 },
                    "100%": { transform: "translateY(0px) rotate(0deg)", opacity: 1 },
                  },
                  animation: isNearBottom ? "spinUp 0.5s ease-out" : "slideDown 0.5s ease-out",
                  "&:hover": {
                    backgroundColor: "#2d0a56",
                    transform: "scale(1.1)",
                  },
                  "& svg": {
                    animation: isNearBottom
                      ? "keyframes { from { transform: translateY(0); } to { transform: translateY(-4px); } } 2s ease-in-out infinite"
                      : "keyframes { from { transform: translateY(0); } to { transform: translateY(4px); } } 2s ease-in-out infinite",
                  }
                }}
                aria-label={isNearBottom ? "back to top" : "go to pagination"}
                title={isNearBottom ? "Back to Top" : "Go to Pagination"}
              >
                {isNearBottom ? (
                  <KeyboardArrowUp size="small" sx={{ fontSize: { xs: 28, md: 32 } }} />
                ) : (
                  <KeyboardArrowDown size="small" sx={{ fontSize: { xs: 28, md: 32 } }} />
                )}
              </Fab>
            )}

          </>
          <FooterNote />
          <Footer />
        </Box>
      </>
    </Box>
  );
};
export default OrderDetails;
